import { Container, Box } from "@mui/material";
import { HeroSection } from "../Components/HeroSection";
import { EducationSection } from "../Components/EducationSection";
import { ExperienceSection } from "../Components/ExperienceSection";
import { ProjectsSection } from "../Components/ProjectSection";
import { SkillsSection } from "../Components/SkillsSection";
import { AwardsSection } from "../Components/AwardsSection";
import { RecommendationsSection } from "../Components/Recommendation";

const Profile = () => {
  return (
    <Box
      sx={{
        backgroundColor: "var(--body_background)",
        minHeight: "100vh",
        py: { xs: 4, md: 6 },
      }}
    >
      <Container maxWidth="lg">
        <HeroSection />
        <EducationSection />
        <SkillsSection />
        <ExperienceSection />
        <ProjectsSection limit={4} />
        <AwardsSection />
        <RecommendationsSection />
      </Container>
    </Box>
  );
};

export default Profile;
